import { render, staticRenderFns } from "./MensagemConfirmacao.vue?vue&type=template&id=344a5eaa&scoped=true"
import script from "./MensagemConfirmacao.vue?vue&type=script&lang=js"
export * from "./MensagemConfirmacao.vue?vue&type=script&lang=js"
import style0 from "./MensagemConfirmacao.vue?vue&type=style&index=0&id=344a5eaa&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344a5eaa",
  null
  
)

export default component.exports